<script>
  import {link} from 'svelte-spa-router'
  import {logOut} from '../../js-core/conn/auth/auth-main'
  import {
      Collapse,
      Navbar,
      NavbarToggler,
      NavbarBrand,
      Nav,
      NavItem,
      NavLink,
      UncontrolledDropdown,
      DropdownToggle,
      DropdownMenu,
      DropdownItem
  } from 'sveltestrap';
  let isOpen = false;
  function handleUpdate(event) {
    isOpen = event.detail.isOpen;
  }
  export let vis = {
      home: true,
      campaigns: false,
      tvSpot: false
  }
  function handleClick(pageToNavTo) {
      for(var key in vis) {
          vis[key] = false;
      }
      vis[pageToNavTo] = true;
      collapse(null)
  }

  export function collapse(e) {
    isOpen = false
    return e
  }
</script>
<style>

:global(.navbar) {
  position: relative;
  width: 100%;
  background-color: rgba(16,16,16,1)!important;
  padding: 1rem 3rem; 
}
:global(.navbar-toggler) {
  filter: invert(1);
}
:global(.navbar a) {
  white-space: nowsrap;
  font-family: Montserrat;
  font-style: normal;
  font-weight: lighter;
  font-size: 24px;
  cursor: pointer;
  color: rgb(202, 202, 202)!important;
  margin-right: 3rem;
}
:global(.navbar a:hover) {
  color: rgba(255,255,255,1)!important;
}
:global(.navbar img) {
    text-decoration: none;
    color: rgb(184, 184, 184)!important;
    height: 70px;
}

</style>
<Navbar color="dark" light expand="md">
  <NavbarBrand href="#/brite-host/tv-home">
    <img src="static/logos/BriteSignalJustLogo.png" alt="brite signal logo">
  </NavbarBrand>
  <NavbarToggler on:click={() => (isOpen = !isOpen)} />
  <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
    <Nav class="mr-auto" navbar>
      <NavItem>
        <NavLink href="#/brite-host/tv-home" on:click={collapse}>Home</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href="#/brite-host/manage-groups" on:click={collapse}>Screens</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href="#/brite-host/profile" on:click={collapse}>Profile</NavLink>
      </NavItem>
      <NavItem>
        <button class="Page_Title Log_Out_Box normal" style="height: 100%;" on:click={logOut}>
          <div class="Log_Out_Text">
            Log out
          </div>
        </button>
      </NavItem>
    </Nav>
  </Collapse>
</Navbar>
<!-- <Navbar bg="light" expand="lg">
  <Navbar.Brand href="#home">React-Bootstrap</Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav">
    <Nav className="mr-auto">
      <Nav.Link href="#home">Home</Nav.Link>
      <Nav.Link href="#link">Link</Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar> -->
<!-- <nav class="navbar navbar-expand-lg navbar-light bg-dark">
  <a class="navbar-brand" href="/brite-host/tv-home" use:link>
    <img src="static/logos/BriteSignalJustLogo.png" alt="brite signal logo">
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
    </ul>
  </div>
</nav> -->